var BaseViews = require('../../base');
require('./vendor-select-selected/vendor-select-selected.scss');

var ProductVendorEntities = require('../../../admin-app/entities/product-vendor');

var VendorSelect = BaseViews.LayoutView.extend({
  template: require('./vendor-select-selected/vendor-select.html')
});

var VendorSelected = BaseViews.LayoutView.extend({
  className: 'fmcy-vendor-selected',
  template: require('./vendor-select-selected/vendor-selected.html'),
  serializeData: function () {
    return {
      vendorName: this.model.get('name')
    }
  }
});

var VendorSelectSelected = BaseViews.LayoutView.extend({
    _tabs: null,
    _dropdownList: null,
    template: require('./vendor-select-selected/vendor-select-selected.html'),
    className: 'fmcy-vendor-select-selected fmcy-search-toggle-btn',
    regions: {
        childRegion: '.fmcy-vendor-selected-child-region'
    },
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(options || {}, {
            _menuState: null,
            appChannel: null
        });
    },
    events: {
      'click': 'onClick'
    },
    onClick: function () {
      if (this.options._menuState.get('filterVendor') !== null && !isNaN(this.options._menuState.get('filterVendor'))) {
        this.options.appChannel.trigger(
            'search:options:changed',
            {
                filterVendor: null
            }
        );
      } else {
        this.options.appChannel.trigger('menu:search:view', {
          searchType: 'vendor'
        });
      }
    },
    _getVendorModel: function (id) {
      var $deferred = $.Deferred();
      var vendorModel = new ProductVendorEntities.ProductVendorModel({ id: id });
      vendorModel.fetch().then(function () {
          $deferred.resolve(vendorModel);
      }).fail(function () {
          $deferred.reject();
      });
      return $deferred;
    },
    _renderSelectedVendor: function (vendorId) {
      var self = this;
      if (vendorId) {
        this._getVendorModel(vendorId).then(function (vendorModel) {
          self.vendorSelected = new VendorSelected({
            model: vendorModel
          });
          self.childRegion.show(self.vendorSelected);
        });
      } else {
        self.vendorSelect = new VendorSelect();
        self.childRegion.show(self.vendorSelect);
      }
    },
    onRender: function() {
      var self = this;
      this.options._menuState.on('change:filterVendor', function (model) {
        self._renderSelectedVendor(model.get('filterVendor'));
      });

      if (this.options._menuState && this.options._menuState.get('filterVendor')) {
        self._renderSelectedVendor(this.options._menuState.get('filterVendor'));
      }
    }
});
module.exports = VendorSelectSelected;



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/subfilters/vendor-select-selected.js
 ** module id = 472
 ** module chunks = 1 7 43 115
 **/